// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent_2/work/861f9e7e0cb825c7/node_modules/core-js/modules/_to-object.js
// module id = RT4T
// module chunks = 15